<sc-flex fitHeight stretchContent vertical>
  <sc-title>{{'step title' | translate: ['tmc.transport-attach-detach.dialog.step.title.select-action',
    translationService.language]}}</sc-title>
  <sc-content-spacer [vertical]="true"></sc-content-spacer>
  <div class="warning" *ngIf="stepperModel.workingData.warningDictionaryKey">
    {{'Warning! transport is not assigned to processing position!'| translate:
    [stepperModel.workingData.warningDictionaryKey, translationService.language] }}
  </div>
  <sc-content-spacer [vertical]="true" [double]="true"></sc-content-spacer>
  <sc-flex-fitting-content vertical>
    <sc-scroll-pane>
      <mat-radio-group [(ngModel)]="selectedAction">
        <sc-flex [stretchContent]="true" [vertical]="clientStatusService.isMobile">
          <sc-flex-fitting-content [disabled]="clientStatusService.isMobile">
            <sc-sub-title>{{'detach' | translate: ['tmc.transport-attach-detach.dialog.label.detach',
              translationService.language]}}</sc-sub-title>
            <sc-content-spacer [vertical]="true"></sc-content-spacer>
            <div>
              <mat-radio-button class="padding-bottom-10" value="{{actions.DETACH_TRUCK}}"
                [disabled]="isDetachTruckDisabled()">
                {{'detach truck' | translate: ['tmc.transport-attach-detach.dialog.option.detachTruck',
                translationService.language]}}
              </mat-radio-button>
            </div>
            <div>
              <mat-radio-button class="padding-bottom-10" value="{{actions.DETACH_TRUCK_AND_TRAILER}}"
                [disabled]="isDetachTruckAndTrailerDisabled()" *ngIf="swapTrailerEnabled()">
                {{'detach truck and trailer' | translate:
                ['tmc.transport-attach-detach.dialog.option.detachTruckAndTrailer',
                translationService.language]}}
              </mat-radio-button>
            </div>
            <div>
              <mat-radio-button class="padding-bottom-10" value="{{actions.DETACH_TRAILER}}"
                [disabled]="isDetachTrailerDisabled()" *ngIf="swapTrailerEnabled()">
                {{'detach trailer' | translate: ['tmc.transport-attach-detach.dialog.option.detachTrailer',
                translationService.language]}}
              </mat-radio-button>
            </div>
            <div>
              <mat-radio-button class="padding-bottom-10" value="{{actions.DETACH_TRAILER_SEMI_TRAILER_TRUCK}}"
                [disabled]="isDetachTrailerSemiTrailerTruckDisabled()">
                {{'detach trailer semi trailer truck' | translate:
                ['tmc.transport-attach-detach.dialog.option.detachTrailerSemiTrailerTruck',
                translationService.language]}}
              </mat-radio-button>
            </div>
          </sc-flex-fitting-content>
          <sc-content-spacer></sc-content-spacer>
          <sc-flex-fitting-content [disabled]="clientStatusService.isMobile">
            <sc-sub-title>{{'attach' | translate: ['tmc.transport-attach-detach.dialog.label.attach',
              translationService.language]}}</sc-sub-title>
            <sc-content-spacer [vertical]="true"></sc-content-spacer>
            <div>
              <mat-radio-button class="padding-bottom-10" value="{{actions.ATTACH_TRUCK}}"
                [disabled]="isAttachTruckDisabled()">
                {{'attach truck' | translate: ['tmc.transport-attach-detach.dialog.option.attachTruck',
                translationService.language]}}
              </mat-radio-button>
            </div>
            <div>
              <mat-radio-button class="padding-bottom-10" value="{{actions.ATTACH_TRAILER}}"
                [disabled]="isAttachTrailerDisabled()" *ngIf="swapTrailerEnabled()">
                {{'attach trailer' | translate: ['tmc.transport-attach-detach.dialog.option.attachTrailer',
                translationService.language]}}
              </mat-radio-button>
            </div>
            <sc-content-spacer [vertical]="true"></sc-content-spacer>
            <sc-sub-title>
              {{'swap trailer' | translate: ['tmc.transport-attach-detach.dialog.label.swap-trailer',
              translationService.language]}}
            </sc-sub-title>
            <sc-content-spacer [vertical]="true"></sc-content-spacer>
            <div>
              <mat-radio-button class="padding-bottom-10" value="{{actions.TRAILER_SWAP}}"
                [disabled]="isTrailerSwapDisabled()">
                {{'trailer swap' | translate: ['tmc.transport-attach-detach.dialog.option.swap-trailer',
                translationService.language]}}
              </mat-radio-button>
            </div>
          </sc-flex-fitting-content>
        </sc-flex>
      </mat-radio-group>
    </sc-scroll-pane>
  </sc-flex-fitting-content>
</sc-flex>
